export default {
    cloneObject(object) {
        return JSON.parse(JSON.stringify(object))
    }
}